module.exports = __webpack_public_path__ + "img/hero-2-mobile.fdbc0029.jpg";